<script lang="ts">
  type Props = {
    checked?: boolean;
    id?: string;
    onchange?: (e: Event) => void;
  };

  let { checked = $bindable(false), id, onchange }: Props = $props();
</script>

<label class="toggle">
  <input type="checkbox" {id} bind:checked {onchange} />
  <span class="track" aria-hidden="true">
    <span class="thumb"></span>
  </span>
</label>

<style lang="scss">
  @use '~/theme/themify' as *;
  @use 'sass:color';

  label.toggle {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }

  input[type='checkbox'] {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
    margin: 0;
  }

  .track {
    position: relative;
    width: 40px;
    height: 22px;
    border-radius: 999px;
    transition: background-color 200ms ease;
    flex-shrink: 0;

    @include themify {
      background-color: #{color.mix(themed('background'), themed('link'), 75%)};
    }
  }

  .thumb {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: white;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
    transition: transform 250ms cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  input:checked + .track {
    @include themify {
      background-color: themed('link');
    }
  }

  input:checked + .track .thumb {
    transform: translateX(18px);
  }

  .toggle:hover .track {
    @include themify {
      background-color: #{color.mix(themed('background'), themed('link'), 60%)};
    }
  }

  .toggle:hover input:checked + .track {
    @include themify {
      background-color: #{color.adjust(themed('link'), $lightness: -8%)};
    }
  }
</style>
